import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE } from '../features/shared/utils/Formatters';

export default function creditLineValidator({
  convenience_fee_type,
  option_terms_rate,
  post_cutoff_live_date,
  pre_cutoff_live_date,
  end_timestamp,
  start_timestamp,
  upcoming_rcl,
} = {}) {
  const result =(
    (option_terms_rate || []).length > 0 &&
    !!convenience_fee_type &&
    !!post_cutoff_live_date &&
    !!pre_cutoff_live_date &&
    !!end_timestamp &&
    !!start_timestamp &&
    !isExpired(end_timestamp)
  )

  return result
}

export const isExpired = end_timestamp => {
   let days_remaining = moment(end_timestamp).tz(DEFAULT_TIMEZONE).endOf('day').diff(
    moment(),
    'days',
    true
   );

   return days_remaining <= 0;
};

export const showExpiringRclBannerNotification = (
  days_remaining,
  upcoming_rcl_start_timestamp
) => {
  return (
    days_remaining < 30 && days_remaining > 0 && !upcoming_rcl_start_timestamp
  );
};


// WEBPACK FOOTER //
// ./src/utils/creditLineValidator.js